/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrderRequest } from '../models/CreateOrderRequest';
import type { GerOrderDetailResponse } from '../models/GerOrderDetailResponse';
import type { OrderDTO } from '../models/OrderDTO';
import type { OrderItem } from '../models/OrderItem';
import type { PaginatedGetAllOrderResponse } from '../models/PaginatedGetAllOrderResponse';
import type { PaginatedGetAllReportOrderItemResponse } from '../models/PaginatedGetAllReportOrderItemResponse';
import type { PaginatedGetAllReportOrderResponse } from '../models/PaginatedGetAllReportOrderResponse';
import type { UpdateOrderAddressRequest } from '../models/UpdateOrderAddressRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OrderService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns string OK
     * @throws ApiError
     */
    public setInfo({
        shopId,
        orderNo,
        requestBody,
    }: {
        shopId: string,
        orderNo: string,
        requestBody: UpdateOrderAddressRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/orders/{orderNo}/info',
            path: {
                'orderNo': orderNo,
            },
            query: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public cancelOrder({
        shopId,
        orderNo,
    }: {
        shopId: string,
        orderNo: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/orders/{orderNo}/cancel',
            path: {
                'orderNo': orderNo,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedGetAllOrderResponse OK
     * @throws ApiError
     */
    public getAllOrder({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 20,
        type,
        startDate,
        endDate,
        isCancel,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
        type?: 'CASH' | 'CREDIT_CARD' | 'BANK_TRANSFER' | 'INSTALLMENT',
        startDate?: string,
        endDate?: string,
        isCancel?: boolean,
    }): CancelablePromise<PaginatedGetAllOrderResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
                'isCancel': isCancel,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public createOrder({
        requestBody,
    }: {
        requestBody: CreateOrderRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns OrderItem OK
     * @throws ApiError
     */
    public getOrderItems({
        shopId,
        orderNo,
    }: {
        shopId: string,
        orderNo: string,
    }): CancelablePromise<Array<OrderItem>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/{shopId}/items',
            path: {
                'shopId': shopId,
            },
            query: {
                'orderNo': orderNo,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GerOrderDetailResponse OK
     * @throws ApiError
     */
    public getOrderDetail({
        shopId,
        orderNo,
    }: {
        shopId: string,
        orderNo: string,
    }): CancelablePromise<GerOrderDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/{orderNo}',
            path: {
                'orderNo': orderNo,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns OrderDTO OK
     * @throws ApiError
     */
    public getTaxInvoice({
        shopId,
        orderNo,
    }: {
        shopId: string,
        orderNo: string,
    }): CancelablePromise<OrderDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/{orderNo}/tax-invoice',
            path: {
                'orderNo': orderNo,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns OrderDTO OK
     * @throws ApiError
     */
    public getReceipt({
        shopId,
        orderNo,
    }: {
        shopId: string,
        orderNo: string,
    }): CancelablePromise<OrderDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/{orderNo}/receipt',
            path: {
                'orderNo': orderNo,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedGetAllReportOrderItemResponse OK
     * @throws ApiError
     */
    public getReportOrderProduct({
        shopId,
        page = 1,
        limit = 20,
        type,
        startDate,
        endDate,
    }: {
        shopId: string,
        page?: number,
        limit?: number,
        type?: 'CASH' | 'CREDIT_CARD' | 'BANK_TRANSFER' | 'INSTALLMENT',
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<PaginatedGetAllReportOrderItemResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/report-by-product',
            query: {
                'shopId': shopId,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedGetAllReportOrderResponse OK
     * @throws ApiError
     */
    public getReportOrder({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 20,
        type,
        startDate,
        endDate,
        isCancel,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
        type?: 'CASH' | 'CREDIT_CARD' | 'BANK_TRANSFER' | 'INSTALLMENT',
        startDate?: string,
        endDate?: string,
        isCancel?: boolean,
    }): CancelablePromise<PaginatedGetAllReportOrderResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/report-by-order',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
                'isCancel': isCancel,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public exportOrderProduct({
        shopId,
        page = 1,
        limit = 20,
        type,
        startDate,
        endDate,
    }: {
        shopId: string,
        page?: number,
        limit?: number,
        type?: 'CASH' | 'CREDIT_CARD' | 'BANK_TRANSFER' | 'INSTALLMENT',
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/export-by-product',
            query: {
                'shopId': shopId,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public exportOrder({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 20,
        type,
        startDate,
        endDate,
        isCancel,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
        type?: 'CASH' | 'CREDIT_CARD' | 'BANK_TRANSFER' | 'INSTALLMENT',
        startDate?: string,
        endDate?: string,
        isCancel?: boolean,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/orders/export-by-order',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
                'isCancel': isCancel,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
